const initialState = {
  userData: null as UserData | null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_USER_DATA":
      return {
        ...state,
        userData: Object.assign({}, state.userData, action.data),
      };

    case "LOGOUT":
      return {
        ...state,
        userData: null,
      };

    default:
      return state;
  }
};
